import React , {useState,useEffect} from 'react';
// import {
//   TransitionGroup,
//   CSSTransition
// } from "react-transition-group";
import ReactCSSTransitionGroup from 'react-transition-group';
import '../assets/pageTransitions.css';
import { Transition } from 'semantic-ui-react';

export default function PageAnimation(ComposedComponent) {
  return (props) => {

  /* HOC : component is like write once and use any where.
    You can pass your any component it will return with your CSSTransition
    for that component  */

    return (
      // <Transition.Group animation='fade' duration={500}>
        <ComposedComponent {...props}>
          {/* {({match}) => (
            <ReactCSSTransitionGroup
              transitionAppear={true}
              transitionAppearTimeout={5000}
              transitionEnter={true}
              transitionLeave={true}
              transitionName="page"
            >
              {props.children}
            </ReactCSSTransitionGroup>
          )} */}
          <Transition.Group animation='fade' visible={true} duration={3000} transitionOnMount={true} mountOnShow={true}>
            {props.children}
          </Transition.Group>
        </ComposedComponent>
      // </Transition.Group>

    )
  };
};
